var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.ready
    ? _c(
        "w-card",
        { style: { height: "100vh" } },
        [
          _c(
            "w-card-title",
            [
              _vm._v(" " + _vm._s(_vm.title) + " "),
              _c("w-spacer"),
              _c(
                "w-link",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: _vm.$ct("common.close"),
                      expression: "$ct('common.close')",
                    },
                  ],
                  attrs: { white: "" },
                  on: {
                    click: function ($event) {
                      return _vm.close()
                    },
                  },
                },
                [
                  _c("w-fa", {
                    staticClass: "mts mr",
                    attrs: { icon: "times" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c("app-edit-contact", {
            ref: "root",
            attrs: { id: _vm.id, value: _vm.contact, "is-info": _vm.isInfo },
            on: {
              input: function ($event) {
                return _vm.onContactChange($event)
              },
              save: function ($event) {
                return _vm.onSave()
              },
              cancel: function ($event) {
                return _vm.close()
              },
              delete: function ($event) {
                return _vm.onDelete()
              },
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }